var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "task_template" } },
    [
      !_vm.packageDisabled
        ? _c(
            "el-divider",
            {
              staticStyle: { "margin-top": "0px" },
              attrs: { "content-position": "center" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", icon: "el-icon-add" },
                  on: { click: _vm.addPanelConfig },
                },
                [_vm._v("添加可选套餐")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.packagePanelConfigs, function (panelItem, index) {
        return _vm.packagePanelConfigs && _vm.packagePanelConfigs.length > 0
          ? _c(
              "Card",
              [
                _c(
                  "Row",
                  { staticStyle: { "max-height": "40px" } },
                  [
                    _c(
                      "Col",
                      { attrs: { span: "23" } },
                      [
                        _c("Search", {
                          attrs: {
                            model: _vm.packagePanelConfigs[index].search,
                            "label-position": "left",
                            elem: _vm.packagePanelConfigs[index].searchElem,
                            submit: false,
                          },
                          on: {
                            "on-changeend": (val, propName) => {
                              _vm.changePackages(val, propName, index)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    !_vm.packageDisabled
                      ? _c(
                          "Col",
                          { attrs: { span: "1" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-delete",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeCollapse(index)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "24" } },
                      [
                        _c("EditTabPanel", {
                          key: `edp${index}`,
                          ref: "editTabPanel",
                          refInFor: true,
                          attrs: {
                            "show-tabs": ["physicalProject", "lisProject"],
                            model: "table",
                            maxHeight: "430px",
                            packagesId: panelItem.search.packagesId,
                            taskProjects: panelItem.taskProjects,
                            taskLisProjects: panelItem.taskLisProjects,
                            projectIds: panelItem.projectIds,
                            lisProjectIds: panelItem.lisProjectIds,
                            localApplicableAgeList: _vm.applicableAgeList,
                            disabled: !(
                              !_vm.itemDisabled &&
                              _vm.packagePanelConfigs[index].search.packagesId
                            ),
                          },
                          on: {
                            "update:packagesId": function ($event) {
                              return _vm.$set(
                                panelItem.search,
                                "packagesId",
                                $event
                              )
                            },
                            "update:packages-id": function ($event) {
                              return _vm.$set(
                                panelItem.search,
                                "packagesId",
                                $event
                              )
                            },
                            "update:taskProjects": function ($event) {
                              return _vm.$set(panelItem, "taskProjects", $event)
                            },
                            "update:task-projects": function ($event) {
                              return _vm.$set(panelItem, "taskProjects", $event)
                            },
                            "update:taskLisProjects": function ($event) {
                              return _vm.$set(
                                panelItem,
                                "taskLisProjects",
                                $event
                              )
                            },
                            "update:task-lis-projects": function ($event) {
                              return _vm.$set(
                                panelItem,
                                "taskLisProjects",
                                $event
                              )
                            },
                            "update:projectIds": function ($event) {
                              return _vm.$set(panelItem, "projectIds", $event)
                            },
                            "update:project-ids": function ($event) {
                              return _vm.$set(panelItem, "projectIds", $event)
                            },
                            "update:lisProjectIds": function ($event) {
                              return _vm.$set(
                                panelItem,
                                "lisProjectIds",
                                $event
                              )
                            },
                            "update:lis-project-ids": function ($event) {
                              return _vm.$set(
                                panelItem,
                                "lisProjectIds",
                                $event
                              )
                            },
                            setTaskProjects: _vm.setTaskProject,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }